module.exports = __webpack_public_path__ + "static/media/login_background.0453c9c6.png";